import React, {
    useMemo,
} from 'react'
import Card from 'app/shared-components/Card'
import {
    useArchivedTableControl,
} from 'app/shared-components/TableControls/ShowArchived'
import CollapsibleTable from 'app/shared-components/CollapsibleTable'
import usePricingRoutes from 'app/SkyNetRoutes/hooks/usePricingRoutes'
import useHasPermission from 'app/hooks/useHasPermission'
import useStyles from 'app/tss/collapsibleTable.styles'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import LongTermLeaseFeesRequests from 'app/requests/ContractBasis/LongTermLeaseFees.requests'
import useRequestTable from 'app/hooks/useRequestTable'

import ContractBasisContextWrapper from '../ContractBasisContextWrapper/ContractBasisContextWrapper'
import LongTermLeaseFeesCreate from './LongTermLeaseFeesCreate'
import LongTermLeaseFeesUpdate from './LongTermLeaseFeesUpdate'
import columns from './LongTermLeaseFees.columns'
import {
    LongTermLeaseFeeFilterRequestView,
} from './LongTermLeaseFees.types'

export default function LongTermLeaseFees({
    id,
}: Readonly<{ id: number }>) {
    const {
        ContractBasis: ContractBasisRoutes,
    } = usePricingRoutes()
    const contractBasisCreate = useHasPermission(['contract_basis_create'])
    const {
        classes,
    } = useStyles()

    const showArchived = useArchivedTableControl('longTermLeaseFees')

    const requestsHandlers = useRequestTable<{ data: LongTermLeaseFeeFilterRequestView }>({
        config: LongTermLeaseFeesRequests.filterRequest,
        params: {},
        defaultValue: {
            filter: {
                contractBasisId: [id],
            },
        },
        key: RequestKeys.getContractBasisLongTermLeaseFees,
        showArchived,
    })

    const actionComponents = useMemo(() => {
        return {
            Update: LongTermLeaseFeesUpdate,
            Create: contractBasisCreate ? LongTermLeaseFeesCreate : undefined,
        }
    }, [contractBasisCreate])

    return (
        <ContractBasisContextWrapper id={id}>
            <div
                data-testid="long-term-lease-fees"
                className={classes.root}
            >
                <Card
                    fullHeight
                    contentClass={classes.cardContent}
                    data-testid="long-term-lease-fees-card"
                >
                    <CollapsibleTable
                        title="Long-term Lease Fees"
                        domainName="longTermLeaseFees"
                        requestHandlers={requestsHandlers}
                        actionComponents={actionComponents}
                        createEnabled={contractBasisCreate}
                        columns={columns}
                        radioSelect
                        uniqField="longTermLeaseFeesNumber"
                        routeParams={ContractBasisRoutes.LongTermLeaseFees.params.map(({
                            name,
                        }) => {
                            return name
                        })}
                    />
                </Card>
            </div>
        </ContractBasisContextWrapper>
    )
}
